import Vue from 'vue'

export default {
  setVehicleGroups: (state, value) => {
    state.vehicleGroups = value
  },
  addVehicleGroupItem: (state, value) => {
    state.vehicleGroups.push(value)
  },
  setSelectedVehicleGroup: (state, value) => {
    state.selectedVehicleGroup = value
  },
  setVehicleGroupInVehicleGroupsArray: (state, payload) => {
    if (state.vehicleGroups && state.vehicleGroups.length > 0) {
      const existingGroup = state.vehicleGroups.find(group => {
        return group.ID === payload.ID
      })
      Object.assign(existingGroup, payload)
    }
  },
  setVehicleGroupValue: (state, data) => {
    Vue.set(state.selectedVehicleGroup, data.key, data.value)
  },
  setVehicleGroupLicensePlates: (state, value) => {
    state.vehicleGroupLicensePlates = value
  },
  addVehicleGroupLicensePlate: (state, value) => {
    state.vehicleGroupLicensePlates.push(value)
  },
  updateVehicleGroupLicensePlate(state, updatedItem) {
    const index = state.vehicleGroupLicensePlates.findIndex(
      plate => plate.ID === updatedItem.ID
    )
    if (index !== -1) {
      state.vehicleGroupLicensePlates[index] = updatedItem
    }
  },
  removeLicensePlateById: (state, licsensePlateId) => {
    const index = state.vehicleGroupLicensePlates.findIndex(
      item => item.ID === licsensePlateId
    )
    state.vehicleGroupLicensePlates.splice(index, 1)
  }
}
